import React from 'react';
import clsx from 'clsx';
import { columnDescription, columnName, columnSelect } from '@/constants/fields';
import SystemFlag from '@/components/SystemFlag';
import NameDescriptionRow from '@/components/table/NameDescriptionRow';

const DictionaryRow = ({
  className,
  columns = [
    columnSelect,
    columnName,
    columnDescription,
  ],
  dictionary,
  onCheckBoxClick,
  selectable,
}) => (
  <NameDescriptionRow
    className={clsx('aridhia-dictionary-row', className)}
    columns={columns}
    description={dictionary.description}
    entity="dictionary"
    name={dictionary.name}
    onSelect={() => onCheckBoxClick(dictionary.code)}
    renderSystemFlag={() => <SystemFlag messageId="dictionary.primary" />}
    selectable={selectable}
    selected={dictionary.selected}
    system={dictionary.primary}
  />
);

export default DictionaryRow;
